import { get, post, put } from '../../api';

export const getFontesDados = (idConfiguracao) => {
  return get(`/api/conectores/fonte/dados/${idConfiguracao}`);
};

export const getFonteDado = (idConfiguracao, id) => {
  return get(`/api/conectores/fonte/dado/${idConfiguracao}/${id}`);
};

export const postFonteDado = (data) => {
  return post('/api/conectores/fonte/dado', data);
};

export const putFonteDado = (data) => {
  return put('/api/conectores/fonte/dado', data);
};
